import React from 'react';
import { motion } from 'motion/react';
import './JoinTableSplash.css';

export default function JoinTableSplash({ onJoin, roomMode }) {
  return (
    <motion.div 
      className="join-splash-overlay"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="join-splash-content">
        <motion.div 
          className="join-card"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          <div className="join-header">
            <img src="/assets/resources/Logo_Icon.png" alt="GV" className="join-logo" />
            <h2>READY TO PLAY?</h2>
            <p>Seat reserved for {roomMode === '56' ? '6-Player 56' : roomMode === 'poker' ? 'Poker' : '28/56'}</p>
          </div>

          <motion.button 
            className="join-btn"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={onJoin}
          >
            TAKE YOUR SEAT
          </motion.button>

          <p className="join-hint">Tapping "Take Your Seat" enables game audio & haptics</p>
        </motion.div>
      </div>
    </motion.div>
  );
}
